<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="select" label="会员等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="input" label="库存会员" name="user_info" placeholder="昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="商品/规格信息" name="product_info" placeholder="商品名、规格、SKU编码"></c-form-item>
                    <!-- <c-form-item type="checkbox" v-model="isStock" name="isStock" :options="[{name: '有库存',value: 1}]" disabled></c-form-item> -->
                </c-form>
			</m-search>
            <m-operate>
                <c-button power="b_cloud_stock_import" @click="importCloudStock()" color="black" icon="excel">导入云仓库存</c-button>
                <c-button power="b_cloud_stock_export" @click="exportData()" color="sys" icon="excel">导出</c-button>
            </m-operate>
			<c-table ref="table">
               <c-table-column type="selector"></c-table-column>
                <c-table-column label="库存会员" width="250">
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image v-if="data.head_photo" :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            {{data.nick_name||'--'}}
                            <span v-if="data.user_manage_mobilephone">({{data.user_manage_mobilephone}})</span>
                        </div>
                    </template>
                </c-table-column>

				<c-table-column
				        label="会员等级"
				        name="level_name"
				        width="80"
				></c-table-column>

                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="300"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="规格名称"
                        name="product_sku_spec"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="SKU编码"
                        name="product_sku_code"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="云仓库存"
                        name="product_count"
                        width="80"
                >
                </c-table-column>
            </c-table>
		</module>
	</page>
</template>
<script>
	import productInfo from '@/components/public/product_info.vue'
	export
	default {
	  name: 'm_cloud_stock',

	  components: {
			productInfo
	  },

	  data() {
		return {
          isStock:[1]
		}
	  },

	  computed: {
	  },

	  watch: {
	  },

	  mounted() {
          this.$refs.search.search();
	  },

	  methods: {
          searchHandle(data = {}) {
              data.isStock = this.isStock;
              this.$refs.table.load({
                  url: '/member_user/stock/list',
                  data
              });
              this.searchDate = data;
          },
          //导入设置云仓库存
          importCloudStock() {
              this.$confirm({
                  title: '导入提示',
                  buttonName: '选择导入文件',  // 确定按钮文字
                  text: '请使用标准模板进行导入 <a href="https://guimi-2025.oss-cn-hangzhou.aliyuncs.com/app_static/excel/%E5%AF%BC%E5%85%A5%E6%89%B9%E9%87%8F%E8%AE%BE%E7%BD%AE%E4%BA%91%E4%BB%93%E5%BA%93%E5%AD%98%20.xlsx" target="_blank" style="color:dodgerblue;">模板下载</a>',
                  resolve: () => {
                      this.uploadFile({
                          message: false,
                          success: data => {
                              this.request({
                                  url: '/member_user/import/stock',
                                  data: {
                                      filePath: data.filePath
                                  },
                                  loading: true,
                                  timeout: false,
                                  success: (data, message) => {
                                      this.$refs.table.update();
                                      this.$confirm({
                                          title: '执行结果',
                                          text: message,  // 提示内容,
                                          buttonName: '确定',  // 确定按钮文字
                                          icon: 'success',
                                          cancelButton: false  // 是否显示取消按钮
                                      });
                                  }
                              });
                          }
                      })
                  }
              });
          },
          //批量导出订单
          exportData() {
              var data = this.searchDate;
              data.job_id = 41;
              this.request({
                  url: '/export_job/add',
                  data: data,
                  loading: true,
                  success: data => {
                      this.$message({
                          text: '导出任务提交成功，请稍后前往任务中心查看'
                      });
                  }
              });
          }
      }
	}
</script>

<style lang="stylus" scoped>
.tag {
    border-radius: 2px;
    padding: 0 5px;
    margin-left: 6px;
    line-height: 18px;
    color: #fff;
}
</style>